import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SliderComponent } from './slider/slider.component';
import { HomeComponent } from './home/home.component';
import { WebComponent } from './web/web.component';
import { PhotographyComponent } from './photography/photography.component';
import { ContactComponent } from './contact/contact.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HeaderComponent } from './header/header.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { FooterComponent } from './footer/footer.component';

import { HttpClientModule } from '@angular/common/http';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { LoadingComponent } from './loading/loading.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpService } from './http.service';
import { InstagramComponent } from './instagram/instagram.component';
import { FacebookComponent } from './facebook/facebook.component';
import { TumblrComponent } from './tumblr/tumblr.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { LoginComponent } from './user/login/login.component';
import { RegisterComponent } from './user/register/register.component';
import { DashboardComponent } from './user/dashboard/dashboard.component';
import { WebDashboardComponent } from './user/dashboard/web-dashboard/web-dashboard.component';
import { PhotographyDashboardComponent } from './user/dashboard/photography-dashboard/photography-dashboard.component';
import { MessageDashboardComponent } from './user/dashboard/message-dashboard/message-dashboard.component';
import { UserDashboardComponent } from './user/dashboard/user-dashboard/user-dashboard.component';
import { ItemDetailsComponent } from './item-details/item-details.component';
import { DashboardHeaderComponent } from './user/dashboard/dashboard-header/dashboard-header.component';
import { ItemEditComponent } from './user/dashboard/item-edit/item-edit.component';
import { ItemAddComponent } from './user/dashboard/item-add/item-add.component';

@NgModule({
  declarations: [
    AppComponent,
    SliderComponent,
    HomeComponent,
    WebComponent,
    PhotographyComponent,
    ContactComponent,
    PageNotFoundComponent,
    HeaderComponent,
    FooterComponent,
    BreadcrumbComponent,
    LoadingComponent,
    InstagramComponent,
    FacebookComponent,
    TumblrComponent,
    SearchBarComponent,
    LoginComponent,
    RegisterComponent,
    DashboardComponent,
    WebDashboardComponent,
    PhotographyDashboardComponent,
    MessageDashboardComponent,
    UserDashboardComponent,
    ItemDetailsComponent,
    DashboardHeaderComponent,
    ItemEditComponent,
    ItemAddComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    CarouselModule,
    GoogleMapsModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  providers: [HttpService],
  bootstrap: [AppComponent]
})
export class AppModule { }
